import { ILocalStorage } from "../api/ILocalStorage";

/**
 * Abstract implementation of LocalStorage wrapper.
 *
 * These methods must be implemented by the concrete implementation:
 * - read
 * - write
 */
export abstract class AbstractLocalStorage implements ILocalStorage {
    protected _section: string;
    protected _data: object;

    /**
     * Creates a wrapper to manage local storage data stored under section
     * @param section section managed by this wrapper
     */
    constructor(section: string) {
        if ((section === undefined) || (section === null) || (section === "")) {
            throw new Error("Section cannot be null or empty");
        }

        this._section = section;
    }

    public abstract read(): Promise<any>;

    public abstract write(): void;

    public hasAttribute(attributeName: string): boolean {
        return this._data.hasOwnProperty(attributeName);
    }

    public getAttribute(attributeName: string): any {
        return this._data[attributeName];
    }

    public setAttribute(attributeName: string, value: any): void {
        this._data[attributeName] = value;
    }

    public deleteAttribute(attributeName: string): void {
        if (!this.hasAttribute(attributeName)) {
            return;
        }

        delete this._data[attributeName];
    }

    public getAttributes(): string[] {
        let attributes: string[] = [];

        for (let attribute in this._data) {
            if (this._data[attribute] !== null) {
                attributes.push(attribute);
            }
        }

        return attributes;
    }
}
